export default __webpack_public_path__ + "static/media/trophy.58d1de1c.svg";